const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

const api = async (endpoint, options, doNotParse = false) => {
  const defaultOptions = {
    credentials: "omit",
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    ...options,
  };

  const auth_token = localStorage.getItem("auth_token");
  if (auth_token) {
    defaultOptions.headers.Authorization = `Bearer ${auth_token}`;
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, defaultOptions);
    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(errorData.message || 'خطایی رخ داد');
      error.data = errorData;
      throw error;
    }
    if (!doNotParse) return response.json();
    return response;
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    console.error("API Error:", error);
    throw error;
  }
};

export default api;
